import { Form, Data, FormField, ModalId, useUIActions, FieldType, FieldValue, O } from "../../../../ui"
import { useState } from "react"
import { validateEmail } from "../../../utils/validationsUtils"

type Props = {
    data?: Data
    onSubmit: (email: string) => void
}

export const EmailForm = (props: Props) => {
    const { data, onSubmit } = props
    const createMode = !data
    
    const [email, setEmail] = useState<O<string>>((data?.email as O<string>))

    const { closeModal } = useUIActions()
    
    const onChangeEmail = (value?: FieldValue) => setEmail(value as O<string>)

    const fields: FormField[] = [
        {
            name: 'email',
            type: FieldType.TEXT,
            defaultValue: email,
            label: 'Email',
            validate: validateEmail,
            onChange: onChangeEmail
        }
    ]

    const handleSubmit = () => {
        onSubmit(email!)
        closeModal(ModalId.EMAIL_FORM)
    }

    const handleCancel = () => closeModal(ModalId.EMAIL_FORM)

    return (
        <Form
            formId="email-form"
            fields={fields}
            createMode={createMode}
            createLabel="Agregar"
            onSubmit={handleSubmit}
            onCancel={handleCancel}
        />
    )
}
